import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'iposcen-ipos-help-faq',
  templateUrl: './ipos-help-faq.component.html',
  styleUrls: ['./ipos-help-faq.component.scss']
})
export class IposHelpFaqComponent implements OnInit, OnChanges {
  @Output() readonly sideNav = new EventEmitter();
  @Input() sideNavData;
  @ViewChild('errorReport') errorReport: ElementRef;
  @ViewChild('specs') specs: ElementRef;
  @ViewChild('gamedemo') gamedemo: ElementRef;
  @ViewChild('windows') windows: ElementRef;
  @ViewChild('devices') devices: ElementRef;
  @ViewChild('password') password: ElementRef;
  @ViewChild('profiles') profiles: ElementRef;
  @ViewChild('intsall') intsall: ElementRef;
  @ViewChild('tileUpgrade') tileUpgrade: ElementRef;
  @ViewChild('ODA') ODA: ElementRef;
  isSubmitErrorReport = true;
  isSpecs = true;
  isGameDemo = true;
  isWindows10s = true;
  isDevices = true;
  isIposPassword = true;
  isMsProfiles = true;
  isIposInstallUninstall = true;
  isIposUpgrade = true;
  isOda = true;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {

  }

  change(data) {
    if (data === 'errorReport') {
      setTimeout(() => {
        this.errorReport.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'specs') {
      setTimeout(() => {
        this.specs.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'gameDemo') {
      setTimeout(() => {
        this.gamedemo.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'windows') {
      setTimeout(() => {
        this.windows.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'device') {
      setTimeout(() => {
        this.devices.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'password') {
      setTimeout(() => {
        this.password.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'profiles') {
      setTimeout(() => {
        this.profiles.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'insunins') {
      setTimeout(() => {
        this.intsall.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'iposUpgrade') {
      setTimeout(() => {
        this.tileUpgrade.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'oda') {
      setTimeout(() => {
        this.ODA.nativeElement.scrollIntoView();
      }, 0);
    }
  }

  showDescription(data) {
    if (data === 'submitErrorReport') {
      this.isSubmitErrorReport = !(this.isSubmitErrorReport);
    } else if (data === 'specs') {
      this.isSpecs = !this.isSpecs;
    } else if (data === 'gameDemo') {
      this.isGameDemo = !this.isGameDemo;
    } else if (data === 'win10s') {
      this.isWindows10s = !this.isWindows10s;
    } else if (data === 'devices') {
      this.isDevices = !this.isDevices;
    } else if (data === 'iposPassword') {
      this.isIposPassword = !this.isIposPassword
    } else if (data === 'MSProfiles') {
      this.isMsProfiles = !this.isMsProfiles;
    } else if (data === 'unInstallIPOS') {
      this.isIposInstallUninstall = !this.isIposInstallUninstall;
    } else if (data === 'upgradeIPOS') {
      this.isIposUpgrade = !this.isIposUpgrade;
    } else if (data === 'aboutODA') {
      this.isOda = !this.isOda;
    }
  }

  navigate() {
    this.sideNav.emit(['installationProcess', '', '']);
  }
}
